import styled from "@emotion/styled";

export const MidSectionRow = styled.div`
padding: 20px 20px;
width: 100%;
gap: 15px;
font-size: 20px;
font-weight: 800;
display:flex;
flex-direction: column;
align-items: center;
justify-items: center;


@media (min-width: 780px) {
  flex-direction: row;
  justify-content:space-between;
  align-items:center;  
}
`